<div class="filter-field-wrapper d-flex align-items-center">
  <ng-template #fieldComponent></ng-template>
</div>
